<template>
  <UserOrderList
    class="order-wrap"
    orderType="c"
  />
</template>

<script>
import UserOrderList from '@/components/Order/order-list.vue';

export default {
  components: {
    UserOrderList,
  },
}
</script>
<style lang="scss" scoped>
  .order-wrap {
    margin-bottom: 64px !important;
    overflow-y: auto;
    @include hideScrollBar(0, 0);
  }
</style>